import React from 'react';
import { DispositifBadge } from '../DispositifBadge';

const CODES = ['annuel', 'nominative', 'archos', 'avenant'];
const eur = (v) => (v || 0).toLocaleString('fr-FR', { maximumFractionDigits: 0 });

export const CompteursDispositif = ({ parDispositif }) => {
  if (!parDispositif) return null;
  return (
    <div className="grid grid-cols-2 md:grid-cols-4 gap-3" data-testid="compteurs-dispositif">
      {CODES.map((c) => (
        <div key={c} className="rounded-xl border bg-white px-4 py-3 shadow-sm flex items-center justify-between" data-testid={`compteur-dispositif-${c}`}>
          <DispositifBadge code={c} testId={`compteur-badge-${c}`} />
          <div className="text-right">
            <p className="text-lg font-bold text-gray-900" data-testid={`compteur-nombre-${c}`}>{parDispositif[c]?.nombre || 0}</p>
            <p className="text-xs text-gray-500" data-testid={`compteur-encaisse-${c}`}>{eur(parDispositif[c]?.montant_encaisse)} EUR encaissés</p>
          </div>
        </div>
      ))}
    </div>
  );
};
